import React from "react";
import { Typewriter } from "react-simple-typewriter";
import logo_text from "../assets/new_logo_with_text(3).png";

const Hero = () => {
  return (
    <section id="home" className="h-screen relative overflow-hidden">
      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source
          src={require("../assets/Website_Banner_Videos/desktop.mp4")}
          type="video/mp4"
          media="(min-width: 1024px)"
        />
        <source
          src={require("../assets/Website_Banner_Videos/tablet.mp4")}
          type="video/mp4"
          media="(min-width: 768px)"
        />
        <source
          src={require("../assets/Website_Banner_Videos/mobile.mp4")}
          type="video/mp4"
        />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>

      {/* Logo */}
      <div className="absolute top-0 left-0 p-4">
        <img
          src={logo_text}
          alt="Logo"
          className="w-32 md:w-44 lg:w-80 object-contain"
        />
      </div>

      {/* Typewriter Text */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          <Typewriter
            words={["Find Your Dream Home", "Real Estate Made Easy"]}
            loop={0}
            cursor
            cursorStyle="_"
            typeSpeed={100}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h1>
      </div>

      {/* Toggle Button */}
      <button
        onClick={() =>
          document
            .getElementById("commitment")
            .scrollIntoView({ behavior: "smooth" })
        }
        className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-white text-primary p-3 rounded-full shadow-lg hover:bg-gray-100 transition"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
    </section>
  );
};

export default Hero;
